import { colors } from './colors';
import { generateSemanticTokensFromColors } from './utils/colors';
export const semanticTokens = {
    colors: {
        ...generateSemanticTokensFromColors(colors),
    },
};
